import React from 'react';
import { Bar } from 'react-chartjs-2';
import 'chart.js/auto';

const StaffWisePerformanceChart = ({ chartData }) => {

    const data = {
        labels: chartData?.staffPerformanceLabel,
        datasets: [
            {
                label: 'Target',
                data: chartData?.staffPerformanceTarget,
                backgroundColor: '#bbc5ee',
                hoverBackgroundColor: '#bbc5ee',
                hoverBorderColor: '#bbc5ee',
                borderColor: '#bbc5ee',
                borderWidth: 1,
                maxBarThickness: 40,
            },
            {
                label: 'Achievement',
                data: chartData?.staffPerformanceAchieved,
                backgroundColor: '#c9c3c3',
                hoverBackgroundColor: '#c9c3c3',
                hoverBorderColor: '#c9c3c3',
                borderColor: '#c9c3c3',
                borderWidth: 1,
                maxBarThickness: 40,
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        datalabels: {
            display: false,
            color: '#fff',
        },
        categoryPercentage: 0.8,
        barPercentage: 0.9,
        plugins: {
            legend: {
                display: false,
            },
            datalabels: {
                display: false, // Ensure no data labels are shown inside the bars
            },
            // tooltip: {
            //     callbacks: {
            //         label: function (context) {
            //             let label = context.dataset.label || '';
            //             if (label) {
            //                 label += ': ';
            //             }
            //             label += new Intl.NumberFormat('en-IN', {
            //                 style: 'currency',
            //                 currency: 'INR',
            //                 minimumFractionDigits: 0,
            //             }).format(context.parsed.y);
            //             return label;
            //         },
            //     },
            // },
        },
        // scales: {
        //     y: {
        //         ticks: {
        //             callback: function (value) {
        //                 return value / 100000 + 'Lac';
        //             },
        //         },
        //     },
        // },
    };

    return (
        <div className='overflow-auto'>
            <Bar data={data} height={406} options={options} />
        </div>
    );
};

export default StaffWisePerformanceChart;